import { Theme, css } from '@emotion/react';

import { Spacing } from 'chatie-design-system';

import { IRecommendSection } from '@model';

const childCSS = (theme: Theme) => css`
  padding: 0px ${Spacing.medium}px;
  margin-bottom: ${Spacing.xxsmall}px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${Spacing.small}px;

  p {
    font-size: 12px;
    font-style: normal;
    line-height: 12px; /* 100% */
    text-align: right;
  }

  .active {
    color: ${theme.colors.main500};
    font-weight: 600;
  }

  .inactive {
    color: ${theme.var.gray400};
    font-weight: 400;
  }

  .chip-container {
  }
`;

type CurationTabProps = {
  sections: IRecommendSection[];
  onClickSection: (section: IRecommendSection) => void;
  selectedSectionId?: number;
};

const CurationTab = ({
  sections,
  onClickSection,
  selectedSectionId,
}: CurationTabProps) => {
  const handleClickSection = (section: IRecommendSection) => {
    onClickSection(section);
  };

  return (
    <div css={childCSS}>
      {sections?.map((childSection) => {
        return (
          <div
            className="chip-container"
            onClick={() => handleClickSection(childSection)}
            key={childSection?.id}
          >
            <p
              className={
                selectedSectionId === childSection?.id ? 'active' : 'inactive'
              }
            >
              {childSection.name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default CurationTab;
